import React from 'react';
import { Heading, Squish } from '@grubhubprod/gh-cookbook-react';

export interface InsightsLocationsHeaderProps {
  maxLocations: number;
}

export function InsightsLocationsHeader({
  maxLocations,
}: InsightsLocationsHeaderProps): JSX.Element {
  return (
    <Squish inset="md">
      <Heading variant="h6">Select up to {maxLocations} locations</Heading>
    </Squish>
  );
}
